import Vue from 'vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'

import HttpMixin from '../src/mixins/Http';
import UtilsMixin from '../src/mixins/Utils';
import RequestStatus from '../src/components/ui/RequestStatus.vue'

// mixins:
Vue.mixin(HttpMixin)
Vue.mixin(UtilsMixin)

// components
Vue.component('request-status', RequestStatus)

Vue.use(VueCookies)
Vue.use(PiniaVuePlugin)

const pinia = createPinia()
Vue.config.productionTip = false

new Vue({
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app')
